import { z } from "zod";
import { createEndpoint, createEndpointWithPagination } from "../createEndpoint";
import type { HttpClient, QueryParams } from "../httpClient";
import { SendProjectReviewRequestResponseSchema } from "../schemas/reviews-v2";
import {
    ExpertProjectsInboxItemSchema,
    ProjectsV2ListQueryParams,
} from "../schemas/projects-v2";
import { createProjectsV2CommonApi } from "./projects-v2.shared";

export function createExpertProjectsV2Api(http: HttpClient, baseUrl: string) {
    const common = createProjectsV2CommonApi(http, baseUrl);
    const projectsBaseUrl = `${baseUrl}/projects`;

    return {
        /**
         * List the authenticated expert's flat V2 project inbox.
         * GET /api/v2/projects/expert
         */
        listInboxProjects: createEndpointWithPagination<
            z.infer<typeof ExpertProjectsInboxItemSchema>,
            unknown,
            unknown,
            ProjectsV2ListQueryParams
        >(http, "GET", "/expert", {
            base: projectsBaseUrl,
            itemSchema: ExpertProjectsInboxItemSchema,
        }),
        /**
         * Send the project's review invitation email now (409 already_requested |
         * already_reviewed, 422 not_eligible | review_emails_disabled).
         * POST /api/v2/expert/projects/:projectId/review-request
         */
        sendReviewRequest: createEndpoint<
            z.infer<typeof SendProjectReviewRequestResponseSchema>,
            { acting_org_id: number },
            QueryParams,
            { projectId: number }
        >(http, "POST", "/:projectId/review-request", {
            base: `${baseUrl}/expert/projects`,
            responseSchema: SendProjectReviewRequestResponseSchema,
            params: ["projectId"],
        }),
        ...common,
    };
}

export type ExpertProjectsV2Api = ReturnType<typeof createExpertProjectsV2Api>;
